var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4621)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8327 7.45905L29.2373 7.05445L28.7821 6.70774C28.2583 6.30875 27.6972 5.95545 27.1045 5.65347C25.8158 4.99681 24.4096 4.71548 22.7651 4.58111C21.1601 4.44998 19.1717 4.44999 16.6749 4.45L16.6533 4.45H16.5302L16.5085 4.45C14.0117 4.44999 12.0234 4.44998 10.4184 4.58111C8.77381 4.71548 7.36768 4.99681 6.0789 5.65347C4.00128 6.71207 2.31212 8.40123 1.25352 10.4789C0.596858 11.7676 0.315532 13.1738 0.181165 14.8183C0.050033 16.4233 0.0500401 18.4117 0.0500489 20.9085L0.0500489 20.9301V21.0532L0.0500489 21.0748C0.0500401 23.5716 0.050033 25.56 0.181165 27.165C0.315532 28.8096 0.596858 30.2157 1.25352 31.5045C1.5555 32.0971 1.9088 32.6582 2.30779 33.1821L2.6545 33.6372L3.05911 33.2326L28.8327 7.45905ZM36.1967 7.65082C36.9289 6.91859 36.9289 5.7314 36.1967 4.99917C35.4644 4.26694 34.2773 4.26694 33.545 4.99917L2.43233 36.1119C1.7001 36.8441 1.7001 38.0313 2.43233 38.7635C3.16457 39.4958 4.35175 39.4958 5.08398 38.7635L7.08603 36.7615C8.09777 37.12 9.19219 37.302 10.4184 37.4022C12.0232 37.5333 14.0113 37.5333 16.5076 37.5333H16.5292H16.6533H16.6748C19.1712 37.5333 21.1603 37.5333 22.7651 37.4022C24.4096 37.2678 25.8158 36.9865 27.1045 36.3299C29.1822 35.2713 30.8713 33.5821 31.9299 31.5045C31.9503 31.4645 31.9703 31.4244 31.99 31.3841C33.9193 32.2252 35.5588 32.9207 36.9189 33.2897C38.4835 33.7141 40.1314 33.8365 41.626 32.8585C43.1206 31.8805 43.6682 30.3216 43.9058 28.7179C44.1335 27.1804 44.1334 25.1709 44.1334 22.7733V22.7336V19.2497V19.21C44.1334 16.8124 44.1335 14.8029 43.9058 13.2655C43.6682 11.6618 43.1206 10.1028 41.626 9.12479C40.1314 8.14679 38.4835 8.26922 36.9189 8.69368C36.1066 8.91405 35.1952 9.25065 34.1826 9.66487L36.1967 7.65082Z",
    fill: "#FFA007",
    stroke: "url(#paint0_linear_1_4621)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8833 15.4917C7.8833 14.7323 8.49891 14.1167 9.2583 14.1167H16.5916C17.351 14.1167 17.9666 14.7323 17.9666 15.4917C17.9666 16.2511 17.351 16.8667 16.5916 16.8667H9.2583C8.49891 16.8667 7.8833 16.2511 7.8833 15.4917Z",
    fill: "url(#paint1_linear_1_4621)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4621",
    x: -24.45,
    y: -20.05,
    width: 93.0834,
    height: 83.8627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4621",
    x: 4.8833,
    y: 11.1167,
    width: 26.0834,
    height: 18.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4621",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4621",
    x1: 0.550049,
    y1: 4.95,
    x2: 33.4785,
    y2: 46.8023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4621",
    x1: 13.0099,
    y1: 17.4525,
    x2: 14.9705,
    y2: 10.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSlash);
export default __webpack_public_path__ + "static/media/video-slash.f2191536e042525e5d5780dd2f070ef7.svg";
export { ForwardRef as ReactComponent };